<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Facebook" class="d-icon d-icon--facebook" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.978 11.989a8.989 8.989 0 1 0-10.394 8.88v-6.282H8.302V11.99h2.282v-1.98c0-2.253 1.342-3.498 3.396-3.498.983 0 2.012.176 2.012.176V8.9h-1.134c-1.117 0-1.465.693-1.465 1.404v1.686h2.493l-.398 2.598h-2.095v6.281c4.297-.674 7.585-4.393 7.585-8.88" fill="#1877F2"/><path d="m15.488 14.587.398-2.598h-2.493v-1.686c0-.711.348-1.404 1.465-1.404h1.134V6.687s-1.03-.176-2.013-.176c-2.053 0-3.395 1.245-3.395 3.497v1.98H8.302v2.6h2.282v6.28a9.036 9.036 0 0 0 2.81 0v-6.28h2.094Z" fill="#fff"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFacebook',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
